import { render } from "./StreamingFilmListCard.vue?vue&type=template&id=37187a9a&scoped=true"
import script from "./StreamingFilmListCard.vue?vue&type=script&lang=js"
export * from "./StreamingFilmListCard.vue?vue&type=script&lang=js"

import "./StreamingFilmListCard.vue?vue&type=style&index=0&id=37187a9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37187a9a"]])

export default __exports__